import React from "react";
import {Redirect, useLocation} from "react-router-dom";

type LegacySettingsRedirectProps = {
    to: string;
};

export function LegacySettingsRedirect({to}: LegacySettingsRedirectProps) {
    const location = useLocation();

    return (
        <Redirect
            to={{
                pathname: to,
                search: location.search,
                hash: location.hash,
            }}
        />
    );
}
